/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoLoginAsMemberResponseDto
 */
export interface WebApiAdminDtoLoginAsMemberResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoLoginAsMemberResponseDto
     */
    siteUrl?: string | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoLoginAsMemberResponseDto interface.
 */
export function instanceOfWebApiAdminDtoLoginAsMemberResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoLoginAsMemberResponseDtoFromJSON(json: any): WebApiAdminDtoLoginAsMemberResponseDto {
    return WebApiAdminDtoLoginAsMemberResponseDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoLoginAsMemberResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoLoginAsMemberResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'siteUrl': !exists(json, 'siteUrl') ? undefined : json['siteUrl'],
    };
}

export function WebApiAdminDtoLoginAsMemberResponseDtoToJSON(value?: WebApiAdminDtoLoginAsMemberResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'siteUrl': value.siteUrl,
    };
}

